// funcion que agrupa los eventos que estan encimados

interface CalendarEvent {
  job: any;
  jobEvent: {
    uid?: string | number;
    startDate: string | Date;
    endDate: string | Date;
  };
}
export const groupOverlappingJobs = (events: CalendarEvent[]) => {
  const groupsEvents: CalendarEvent[][] = [];

  const sortedEvents = [...events].sort((a, b) => {
    const startA = new Date(a.jobEvent.startDate).getTime();
    const startB = new Date(b.jobEvent.startDate).getTime();
    return startA - startB;
  });
  sortedEvents.forEach((event) => {
    const lastGroup = groupsEvents[groupsEvents.length - 1];

    if (!lastGroup) {
      groupsEvents.push([event]);
      return;
    }

    const firstEventInGroup = lastGroup[0];
    const currentStartMinute = Math.floor(new Date(event.jobEvent.startDate).getTime() / 60000);
    const firstStartMinute = Math.floor(new Date(firstEventInGroup.jobEvent.startDate).getTime() / 60000);

    if (currentStartMinute === firstStartMinute) {
      lastGroup.push(event);
    } else {
      groupsEvents.push([event]);
    }
  });

  return groupsEvents;
};
